/*
 * Copyright (c) 2026 Ambits Technologies LLC. All rights reserved.
 *
 * This source code is the proprietary and confidential property of
 * Ambits Technologies LLC. Unauthorized copying, modification, distribution,
 * or use of this software, via any medium, is strictly prohibited.
 *
 * MyAmbits - AI-Powered Location Safety & Social Platform
 * https://myambits.com
 */

import { useEffect, useState } from "react";
import { useSOSEventContext } from "@/contexts/SOSEventContext";
import { useSafeCircleProfiles } from "@/hooks/useSafeCircleProfiles";
import SOSActiveScreen from "./SOSActiveScreen";
import StealthCalculator from "./StealthCalculator";

/**
 * Women-mode orchestrator. When SOS is active and the active profile has
 * opted into stealth, we show a decoy calculator while the underlying SOS
 * event runs (audio, location trail, fan-out all continue via
 * useSOSEventContext). Entering the configured PIN in the calculator
 * swaps back to the real SOS UI.
 */
export default function StealthMode() {
  const { event, active } = useSOSEventContext();
  const { profiles } = useSafeCircleProfiles();
  const profile = profiles.find((p) => p.profileId === event?.profileId) ?? null;
  const [unlocked, setUnlocked] = useState(false);

  useEffect(() => {
    if (!active) setUnlocked(false);
  }, [active]);

  const shouldDecoy =
    active &&
    profile?.mode === "private" &&
    !!profile?.stealthConfig?.enabled &&
    !unlocked;

  if (!active) return null;

  if (shouldDecoy) {
    return (
      <StealthCalculator
        pin={profile?.stealthConfig?.pin ?? "911="}
        onUnlock={() => setUnlocked(true)}
      />
    );
  }
  return <SOSActiveScreen />;
}
